import { getActionType, TYPES } from '../util/redux';
import { RecordType, PAGESIZE } from '../action/record';


const initState = {
    page: 1,
    total: 1,
    request: true,
    data: {},
    hasMore: true,
    msg: ''
}

const type1 = getActionType(RecordType, 'request');
const type2 = getActionType(RecordType, 'success');
const type3 = getActionType(RecordType, 'fail');
const type4 = getActionType(RecordType, 'savepage');

export default function recordsReducer(state = initState, action){
    let { type, payload } = action;
    switch(type){
        case type1:
            return {
                ...state,
                request: true
            }
        case type2:
            // 请求成功
            let page = payload.page;
            let total = payload.total;
            let list = payload.data;
            let odata = state.data;
            odata[page] = list;
            return {
                ...state,
                request: false,
                msg: '',
                data: odata,
                page: page,
                total: total
            }
        case type3:
            // 请求失败
            let rmsg = payload.msg;
            return {
                ...state,
                request: false,
                msg: rmsg
            }
        case type4: 
            return {
                ...state,
                page: payload.page
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./client/reducers/record.js